<template>
  <div v-if="serverDetalii" class="note-conflict-preview">
    <h4>Notă server</h4>
    <div>
      <p class="new-note-preview">{{ serverDetalii }}</p>
    </div>
  </div>
</template>


<script>
export default {
  name: "note-conflict-preview",
  props: {
    serverDetalii: {
      type: String,
      default: ''
    }
  },
}
</script>

<style lang="less">
.note-conflict-preview{
  @media only screen and (min-width: 0) {
    width: 350px;
    min-height: 100%;
    border-left: 1px solid gray;

    background: #F9F9F9;
    padding: 20px;
    border-radius: 8px;
    > h4 {
      font-family: "Montserrat", sans-serif;
      font-size: 1.7rem;
      font-weight: 500;
      color: #FF1313;
      padding: 10px 0;
    }

    > div {
      background-color: white;
      border: 1px solid #B3B3B3;
      border-radius: 4px;
      height: 600px;
      overflow: scroll;
      .new-note-preview {
        white-space: pre-wrap;
        font-family: "Montserrat", sans-serif;
        font-size: 1.7rem;
        color: #000000;
        font-weight: 400;
        padding: 11px 20px;
      }
    }

  }
}
</style>
